var n={};

export { n as a };
